//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconAlertCircleFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M12 22C17.51 22 22 17.51 22 12C22 6.49 17.51 2 12 2C6.49 2 2 6.49 2 12C2 17.51 6.49 22 12 22ZM11 7H13V13H11V7ZM12 14.75C12.69 14.75 13.25 15.31 13.25 16C13.25 16.69 12.69 17.25 12 17.25C11.31 17.25 10.75 16.69 10.75 16C10.75 15.31 11.31 14.75 12 14.75Z" fill="currentColor" /></svg>;
}
export default IconAlertCircleFill;